import { useQuery } from '@tanstack/react-query';
import type { PickupLocation } from '@skytech/shared';

import { api } from '../../lib/api';

/** Active store pickup locations (BOPIS, §4.6), ordered by displayOrder. */
export function usePickupLocations() {
  return useQuery({
    queryKey: ['pickup-locations'],
    queryFn: async () => (await api.get<PickupLocation[]>('/pickup-locations')).data,
    staleTime: 5 * 60_000,
  });
}
